/** `/c/$companyId/banking/movements/$movementId?tab&action` — a bank movement, in every state. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PAYMENT_PAGE_TABS } from "../api/codes";
import { MovementPage } from "../banking/movement/MovementPage";
import { CODE_SETS } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";

const search = z.object({
  // A payment page's three tabs: details, journal, activity.
  tab: z.enum(PAYMENT_PAGE_TABS).optional().catch(undefined),
  /** From the banking page: open the dialog that marks a transfer as arrived. */
  action: z.enum(["receive"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/banking/movements/$movementId")({
  validateSearch: (raw) => search.parse(raw),
  component: MovementRoute,
});

function MovementRoute(): JSX.Element {
  const { companyId, movementId } = Route.useParams();
  const { tab, action } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.MOVE}>
      <MovementPage
        companyId={companyId}
        movementId={movementId}
        tab={tab}
        receive={action === "receive"}
        // Once opened, the address drops it: a reload doesn't open the dialog again.
        onReceiveOpened={() => void navigate({ search: { tab }, replace: true })}
      />
    </CodeGate>
  );
}
